import { Card, CardContent, CardHeader, FormControlLabel, FormLabel, Grid, Grid2, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { CONTACT_WA, PENANGGUNG_JAWAB_BIAYA } from "../../helper/Constant";

function DataLain({ handleChange, data }) {
    return (
        <>
            <Card>
                <CardHeader title="Data Lain-Lain" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <Grid container spacing={2} sx={{ padding: "10px" }}>
                        <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={6} xl={6} lg={6}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Penanggung Jawab Biaya</FormLabel>
                            <Select required name="penanggung_jawab_biaya" value={data?.penanggung_jawab_biaya} onChange={(e) => { handleChange(e.target.name, e.target.value) }} fullWidth>
                                {
                                    Object.entries(PENANGGUNG_JAWAB_BIAYA).map(([key, value]) => {
                                        return (
                                            <MenuItem key={key} value={value}>{value}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={6} xl={6} lg={6}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Nomor Kontak Whatsapp & Email</FormLabel>
                            <Select required name="no_wa" value={data?.no_wa} onChange={(e) => { handleChange(e.target.name, e.target.value) }} fullWidth>
                                {
                                    Object.entries(CONTACT_WA).map(([key, value]) => {
                                        return (
                                            <MenuItem key={key} value={value}>{value}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={6} xl={6} lg={6}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Darimana anda mengetahui Baladz?</FormLabel>
                            <RadioGroup data-radioname="info_baladz" data-required="true" name="info_baladz" value={data?.info_baladz} onChange={(e) => { handleChange(e.target.name, e.target.value) }} row>
                                <FormControlLabel value={"Brosur"} control={<Radio></Radio>} label="Brosur"></FormControlLabel>
                                <FormControlLabel value={"Spanduk"} control={<Radio></Radio>} label="Spanduk"></FormControlLabel>
                                <FormControlLabel value={"Medsos"} control={<Radio></Radio>} label="Medsos"></FormControlLabel>
                                <FormControlLabel value={"Sosialisasi"} control={<Radio></Radio>} label="Sosialisasi/Kunjungan"></FormControlLabel>
                                <FormControlLabel value={"Pameran"} control={<Radio></Radio>} label="Pameran"></FormControlLabel>
                                <FormControlLabel value={"Lainya"} control={<Radio></Radio>} label={<><TextField name="info_baladz_lainya" value={data?.info_baladz_lainya} disabled={(data?.info_baladz === "Lainya") ? false : true} required={(data?.info_baladz === "Lainya") ? true : false} label="Lainya" variant="outlined" onChange={(e) => { handleChange(e.target.name, e.target.value) }}></TextField></>}></FormControlLabel>
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    )
}

export default DataLain;